import { HttpHeaders } from '@angular/common/http';
import { GenericConstants } from '../../enums/generic-constants.enum';

/** Como el resto de servicios del backoffice: el JWT va en cada petición, no en un interceptor. */
export function authHeaders(): HttpHeaders {
  return new HttpHeaders()
    .set('Content-Type', 'application/json')
    .set('Authorization', localStorage.getItem(GenericConstants.STORAGE_ACCESS_TOKEN) || '');
}
